export const getters = {
  getEmployees(state) {
    return state.employees;
  },
}
